import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLeads } from '../utils/api';
import { StatusBadge, EmptyState, formatDate, getTodayStr } from '../components/UI';
import { useLeadLookups } from '../hooks/useLeadLookups';

const FILTERS = [
  { key: 'all', label: 'All Pending' },
  { key: 'overdue', label: 'Overdue' },
  { key: 'today', label: 'Today' },
  { key: 'upcoming', label: 'Upcoming' },
];

export default function Followups() {
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const { statuses } = useLeadLookups();
  const navigate = useNavigate();
  const today = getTodayStr();
  const closedNames = statuses.filter(s => Number(s.is_closed)).map(s => s.name);

  const load = useCallback(() => {
    getLeads()
      .then(r => setLeads(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = leads
    .filter(l => l.followup_date && !closedNames.includes(l.status))
    .filter(l => {
      if (filter === 'overdue') return l.followup_date < today;
      if (filter === 'today') return l.followup_date === today;
      if (filter === 'upcoming') return l.followup_date > today;
      return true;
    }).sort((a, b) => a.followup_date.localeCompare(b.followup_date));

  const cls = (d) => d < today ? 'overdue' : d === today ? 'today' : 'upcoming';
  const tag = (d) => d < today ? 'Overdue' : d === today ? 'Today' : 'Upcoming';

  return (
    <div>
      <div className="section-header">
        <div className="section-title">Follow-up Tracker</div>
      </div>
      <div className="filters">
        {FILTERS.map(f => (
          <button key={f.key} className={`filter-btn${filter === f.key ? ' active' : ''}`} onClick={() => setFilter(f.key)}>{f.label}</button>
        ))}
      </div>
      {loading ? (
        <div style={{ padding: 32, textAlign: 'center', color: 'var(--gray-400)' }}>Loading...</div>
      ) : filtered.length === 0 ? (
        <EmptyState icon="ti-calendar-check" text="No follow-ups in this category" />
      ) : (
        filtered.map(l => (
          <div key={l.id} className={`fc-item ${cls(l.followup_date)}`} onClick={() => navigate(`/leads/${l.id}`)}>
            <div style={{ minWidth: 80, fontSize: 11, fontWeight: 600, color: 'var(--gray-400)' }}>{formatDate(l.followup_date)}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--black)' }}>{l.name}</div>
              <div style={{ fontSize: 11, color: 'var(--gray-400)' }}>{l.company} · {l.service}</div>
            </div>
            <StatusBadge status={l.status} statuses={statuses} />
            <span className={`fc-tag ${cls(l.followup_date)}`}>{tag(l.followup_date)}</span>
          </div>
        ))
      )}
    </div>
  );
}